import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import styles from './ManualSearchCandidatesFetchModal.module.scss';
import { getSourceImage, getSourceName } from '../../../Utils/SourceUtils';
import { getManualSearchCandidatesFetchApiStatus } from '../../../Reducers/ManualSearchCandidateReducer';

const mapStateToProps = (state, props) => {
  const sourceName = getSourceName(props.source);
  return {
    apiStatus: getManualSearchCandidatesFetchApiStatus(state, { jobId: props.jobId, source: sourceName }),
  };
};

const sourceImgIconStyle = { fontSize: 24, height: 24, verticalAlign: 'middle' };

function ManualSearchSourceProgressLoader(props) {
  const { source, apiStatus, userConfig: config } = props;
  const sourceName = getSourceName(source);
  if (sourceName === 'All') return null;
  const updateSourceName = sourceName === 'Active' ? config?.ActiveChannelAlias || 'Active' : sourceName;
  return (
    <div className={styles.sourceItemWrapper}>
      <div className={styles.sourceItem}>
        <div>{getSourceImage(source, sourceImgIconStyle)}</div>
        <div className={styles.sourceName}>{updateSourceName}</div>
      </div>
      <div className={styles.divider} />
      <div className={styles.timeWrapper}>
        {apiStatus === 'FAILED' ? (
          <div className={styles.errorMessageWrapper}>
            <div className={styles.closeIcon}>
              <Icon type="close-circle" theme="filled" />
            </div>
            <span className={styles.errorMessageText}>Failed to source</span>
          </div>
        ) : (
          <>
            {apiStatus === 'INPROGRESS' ? (
              <Icon type="loading" />
            ) : (
              <Icon type="check-circle" theme="filled" className={styles.checkCircle} />
            )}
            <div className={styles.secondsText}>{`${apiStatus === 'INPROGRESS' ? 'Processing' : 'Completed'} `}</div>
          </>
        )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(ManualSearchSourceProgressLoader);
export { ManualSearchSourceProgressLoader as ManualSearchSourceProgressLoaderWithoutStore };
